
import { createContext, useEffect, useReducer } from "react";
import CartReducer from "./CartReducer";

const INITIAL_STATE = {
    // cart: JSON.parse(localStorage.getItem("cart")) || [],
    cart: [],
    message: "",
    isFetchingAdd: false,
    errorAdd: false,
    messageEtat: "",
    isFetchingEtatAdd: false,
    errorEtatAdd: false,
    isFetchingGetOne: false,
    errorGetOne: false,
};


export const CartContext = createContext(INITIAL_STATE);

export const CartContextProvider = ({ children }) => {
    const [state, dispatch] = useReducer(CartReducer, INITIAL_STATE);
      
      // useEffect(()=>{
      //   localStorage.setItem("cart", JSON.stringify(state.cart))
      // },[state.cart])
    
    return (
      <CartContext.Provider
        value={{
          cart: state.cart,
          message: state.message,
          isFetchingAdd: state.isFetchingAdd,
          errorAdd: state.errorAdd,
          messageEtat: state.messageEtat,
          isFetchingEtatAdd: state.isFetchingEtatAdd,
          errorEtatAdd: state.errorEtatAdd,
          isFetchingGetOne: state.isFetchingGetOne,
          errorGetOne: state.errorGetOne,
          dispatch,
        }}
      >
        {children}
      </CartContext.Provider>
    );
  };